import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent {
  @Input() disabled = false;
  @Input() type: 'button' | 'submit' = 'button';
  @Input() full = false;
  @Input() status: 'confirm' | 'cancel' = 'confirm';

  @HostBinding('class.block') get isEnabled(): boolean {
    return this.full;
  }
}
